<template>
  <a-modal
    wrapClassName="create-user-modal"
    :visible="visible"
    width="600px"
    centered
    :mask-closable="false"
    :body-style="bodyStyle"
    :keyboard="false"
    :closable="false"
  >
    <template #title>
      <header>
        <span>Invitar a nuevos usuarios</span>

        <a-button type="text" aria-label="Close" @click="handleCloseModal">
          <CloseOutlined />
        </a-button>
      </header>
    </template>

    <div class="scrollbar">
      <!-- <div class="slots">
        <a-tag color="green"> Slots disponibles: {{ userData?.customer?.slots - total }} </a-tag>
      </div> -->
      <div class="title">
        <p class="title__send">Envía invitaciones a nuevos usuarios por correo electrónico</p>
        <span>
          Ingresa correos electrónicos separados por comas y selecciona un perfil para su
          asignación. Recuerda que se eliminarán los correos duplicados. Por último, se les enviará
          de manera automática una invitación para unirse a tu equipo de trabajo.
        </span>
      </div>
    </div>
    <CustomScrollbar height="356px">
      <section class="form">
        <a-form ref="formRef" :model="formState" layout="vertical" hide-required-mark>
          <div :id="'fieldset-' + index" v-for="(item, index) in formState.invites" :key="item.key">
            <a-form-item
              :name="['invites', index, 'emails']"
              :rules="[{ required: true, validator: checkEmails, trigger: 'change' }]"
            >
              <template #label>
                <span>
                  <span class="icon-required">*</span>Correos electronicos
                  <a-tooltip>
                    <template #title>
                      <div class="flex__items">
                        <div class="state__color--green"></div>
                        <span>Correo válido</span>
                      </div>
                      <div class="flex__items">
                        <div class="state__color--red"></div>
                        <span>Correo inválido</span>
                      </div>
                      <div class="flex__items">
                        <div class="state__color--gray"></div>
                        <span>Correo sin slot disponible</span>
                      </div>
                    </template>
                    <InfoCircleOutlined class="anticon-question" />
                  </a-tooltip>
                </span>
              </template>

              <a-textarea
                v-model:value="item.emails"
                class="tagTextArea"
                name="addTagifyTextArea"
                :placeholder="showPlaceholder"
                :rows="5"
                @change="showConfrimationModal = true"
              />
            </a-form-item>
            <a-form-item
              class="form__item profile"
              :name="['invites', index, 'profile']"
              :rules="[{ required: true, message: 'Campo requerido' }]"
            >
              <template #label>
                <span> <span class="icon-required">*</span>Perfil asignado </span>
              </template>
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="item.profile"
                class="form__item"
                placeholder="Seleccionar tipo de perfil"
                @change="showConfrimationModal = true"
              >
                <a-select-option v-for="profile in profiles" :key="profile.id">{{
                  profile.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <div class="delete">
              <span
                v-if="formState.invites.length > 1"
                class="dynamic-delete-button"
                :disabled="formState.invites.length === 1"
                @click="removeDomain(item)"
              >
                Eliminar sección
              </span>
            </div>
            <div class="line"></div>
          </div>

          <a-form-item>
            <a-button type="link" id="linkButtonAdd" class="button--add" @click="newDomain">
              <PlusOutlined />
              Agregar invitación para otro perfil
            </a-button>
          </a-form-item>
        </a-form>
      </section>
    </CustomScrollbar>
    <template #footer>
      <a-button key="back" @click="handleCloseModal({ back: true })"> Volver </a-button>
      <a-button
        id="sent-invitation"
        key="submit"
        type="primary"
        :disabled="total === 0"
        @click="handleOk"
        :loading="loading"
      >
        Enviar invitación
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent, ref, reactive, computed, createVNode, h } from "vue";
import {
  PlusOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { Modal, message } from "ant-design-vue";
import { useStore } from "vuex";
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { UserCreationType } from "../../utils/constants";
import { regexpEmailFormat } from "@/app/shared/utils/constants";

export default defineComponent({
  components: {
    PlusOutlined,
    InfoCircleOutlined,
    CustomScrollbar,
    CloseOutlined,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    slotsInfo: {
      type: Object,
      default: null
    },
    isClientBeexcc: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const store = useStore();
    const isDisabled = ref(true);
    const indexTextArea = ref(0);
    const loading = ref(false);
    const showConfrimationModal = ref(false);
    const userData = computed(() => store.getters["getDataUser"]);
    const total = ref(0);
    const regex = RegExp(regexpEmailFormat);
    const collectionEmails = [];
    const formState = reactive({
      invites: [],
    });
    const rules = {
      invites: [{ required: true, type: "email", message: "Campo requerido", trigger: "blur" }],
    };
    const formRef = ref();
    const handleOk = () => {
      formRef.value.validateFields().then(async () => {
        const invites = [];
        try {          
          formState.invites.forEach((invite) => {
            const emails = JSON.parse(invite.emails);
            emails.forEach((email) => {
              invites.push({
                email: email.value,
                profile: invite.profile,
              });
            });
          });
          loading.value = true;

          const body = {
            type: UserCreationType.Email,
            users: invites,
          };

          await store.dispatch("createNewUser", body);
          context.emit("update");
          formRef.value.resetFields();
          resetForm();
          total.value = 0;
          context.emit("onCloseModal");
          loading.value = false;
        } catch (error) {
          loading.value = false;
          let errorMessage = "Ha ocurrido un error";
          if (error.status === 400 && error.data?.code === "slots") {
            const slotsCreated = invites?.length;
            const slotsAvailible = props.slotsInfo?.slot_type_billing === 'Postpago' ? remainingSlots.value : remainingPrepaidSlots.value;
            const neededSlots = slotsCreated - slotsAvailible;
            const totalSlots = (props.slotsInfo?.slots_invoice ?? 0) - (props.slotsInfo?.slot_deleted ?? 0);
            // const neededSlots = error.data.required;
            
            const modalType = props.isClientBeexcc ? Modal.warning : Modal.confirm;

            modalType({
              centered: true,
              icon: h(ExclamationCircleOutlined),
              title: props.isClientBeexcc
                ? "No cuentas con slots suficientes para crear nuevos usuarios"
                : `Necesitas “${neededSlots}” slots para agregar nuevos usuarios en la plataforma`,
              content: props.isClientBeexcc
                ? `Actualmente, no puedes crear más de ${totalSlots} usuarios en la plataforma. Para agregar más slots, contáctate con tu Partner.`
                : `Actualmente, no cuentas con slots disponibles para enviar “${slotsCreated}” invitaciones a los correos ingresados.`,
              okText: props.isClientBeexcc ? "Entendido" : "Comprar slots",
              okType: props.isClientBeexcc ? "default" : "primary",
              onOk: props.isClientBeexcc ? undefined : () => emit("openBuyModal", neededSlots),
            });
          } else {
            errorMessage = error.getErrorMessage();
            message.error(errorMessage);
          }
        }
      });
    };
    const remainingSlots = computed(
      // () => (props.slotsInfo?.slots_invoice ?? 0) - (props.slotsInfo?.slot_assigned ?? 0)
      () => remainingPrepaidSlots.value
    );

    const remainingPrepaidSlots = computed(
      () =>
        (props.slotsInfo?.slots_invoice ?? 0) -
        (props.slotsInfo?.slot_assigned ?? 0) -
        (props.slotsInfo?.slot_deleted ?? 0)
    );
    const resetForm = () => {
      formState.invites = [];
      formState.invites.push({
        emails: [],
        profile: null,
        key: Date.now(),
      });
      setTimeout(() => {
        addTagify();
      }, 10);
      indexTextArea.value = 0;
    };

    const removeDomain = (item) => {
      const index = formState.invites.indexOf(item);
      if (index !== -1) {
        if (formState.invites[index].emails.length > 0) {
          const emails = JSON.parse(formState.invites[index].emails);
          emails.forEach((email) => {
            const indexEmail = collectionEmails.indexOf(email.value);
            collectionEmails.splice(indexEmail, 1);
          });
        }
        indexTextArea.value--;
        if (index == indexTextArea.value + 1) {
          document
            .getElementById("fieldset-" + indexTextArea.value)
            .scrollIntoView(0, { block: "end", behavior: "smooth" });
        } else {
          document
            .getElementById("fieldset-" + index)
            .scrollIntoView(0, { block: "end", behavior: "smooth" });
        }

        formState.invites.splice(index, 1);
      }
    };

    const addDomain = () => {
      formState.invites.push({
        emails: [],
        profile: null,
        key: Date.now(),
      });
      setTimeout(() => {
        addTagify();
      }, 10);
      return true;
    };
    const settings = {
      delimiters: ";|,|\n| ",
      duplicates: false,
      editTags: {
        clicks: 1,
      },
      dropdown: {
        enabled: 0,
      },
      validate: (tagData) => {
        const index = collectionEmails.indexOf(tagData.value);
        return index < 0;
      },
      transformTag: (tagData) => {
        const slots = userData.value.customer.slots - 1;
        if (regex.test(tagData.value)) {
          if (total.value > slots) {
            tagData.style = "--tag-bg: #f5f5f5; border: 1px solid #bfbfbf;";
          } else {
            tagData.style = "--tag-bg: #f6ffed; border: 1px solid #b7eb8f;";
          }
        } else {
          tagData.style = "--tag-bg: #fff1f0; border: 1px solid #ffa3a0;";
        }
      },
    };
    const addTagify = () => {
      const element = document.querySelectorAll("[name='addTagifyTextArea']");
      let tag;
      element.forEach((el) => {
        tag = new Tagify(el, settings);
      });
      tag?.on("add", (e) => {
        collectionEmails.push(e.detail.data.value.toString());
        showConfrimationModal.value = true;
        total.value++;
      });
      tag?.on("remove", (e) => {
        const index = collectionEmails.indexOf(e.detail.data.value.toString());
        collectionEmails.splice(index, 1);
        total.value--;
        if (total.value == 0) {
          showConfrimationModal.value = false;
        }
      });
    };

    const checkEmails = async (rule, value) => {
      let valid = true;
      if (value === "" || value.length === 0) {
        isDisabled.value = true;
        return Promise.reject("Campo requerido");
      }
      const arr = JSON.parse(value);
      arr.forEach((item) => {
        if (!regex.test(item.value)) {
          valid = false;
        }
      });
      if (!valid) {
        isDisabled.value = true;
        return Promise.reject("Se detectaron algunos correos inválidos");
      } else {
        isDisabled.value = false;
        return Promise.resolve();
      }
    };
    addDomain();
    return {
      formRef,
      formState,
      handleOk,
      resetForm,
      removeDomain,
      addDomain,
      loading,
      rules,
      settings,
      addTagify,
      total,
      collectionEmails,
      checkEmails,
      showConfrimationModal,
      indexTextArea,
      userData,
      isDisabled,
    };
  },
  data() {
    return {
      bodyStyle: {
        height: "533px",
        loading: false,
        padding: "14px 24px",
      },
    };
  },
  computed: {
    showPlaceholder() {
      if (this.formState.invites[this.indexTextArea]?.emails.length === 0) {
        return "Escribir correos electronicos";
      } else {
        return "";
      }
    },
    profiles() {
      return this.$store.getters["getProfileList"];
    },
  },
  created() {
    this.$store.dispatch("fetchAllProfiles");
    this.$store.dispatch("fetchLoggedBusiness");
  },
  updated() {
    setTimeout(() => {
      this.addTagify();
    }, 10);
  },
  methods: {
    async newDomain() {
      await this.addDomain();
      this.indexTextArea++;
      if (this.indexTextArea >= 0) {
        document
          .getElementById("linkButtonAdd")
          .scrollIntoView(0, { block: "end", behavior: "smooth" });
      }
    },
    handleCloseModal({ back = false } = {}) {
      if (this.showConfrimationModal) {
        this.handleConfirmationClose({ back });
      } else {
        this.handleCancel({ back });
      }
    },
    handleConfirmationClose({ back = false } = {}) {
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
        width: 450,
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel({ back }),
        centered: true,
        okText: "Sí, descartar cambios",
        cancelText: "No, seguir editando",
      });
    },
    handleCancel({ back = false } = {}) {
      this.resetForm();
      this.total = 0;
      this.showConfrimationModal = false;
      this.$emit(back ? "back" : "onCloseModal");
    },
  },
});
</script>

<style lang="sass">
.tagTextArea.tagify
  height: 100px
  max-height: 100px
  overflow: auto
</style>

<style lang="sass" scoped>
header
  display: flex
  justify-content: space-between
  align-items: center

.form
  width: 70%
  margin: 0 auto
  margin-top: 30px

.title__send
  font-size: 16px
  font-weight: 600

.space
  font-weight: 600

.form__item
  margin-top: 15px
  margin-bottom: 4px

.state__color--green
  border-radius: 50%
  height: 8px
  width: 8px
  margin-right: 12px
  background: $green-6

.state__color--red
  border-radius: 50%
  height: 8px
  width: 8px
  margin-right: 12px
  background: $red-6

.state__color--gray
  border-radius: 50%
  height: 8px
  width: 8px
  margin-right: 12px
  background: $gray-6

.flex__items
  display: flex
  align-items: center

.slots
  margin-bottom: 10px

:deep(.ant-select-multiple .ant-select-selection-item)
  background: #F6FFED
  border: 1px solid #52C41A

.dynamic-delete-button
  color: $red-6
  cursor: pointer

.line
  margin-bottom: 10px
  background: #E8E8E8
  height: 1px
  margin-left: -40px
  margin-right: -40px

.button--add
  width: 100%
  border: none
  margin-top: 10px
  color: #1890ff

.delete
  display: flex
  flex-direction: row-reverse
  margin-bottom: 5px
.invalid_tags
  color: $red-6
  font-size: 14px
.scrollbar
  margin-bottom: 13px
.icon-required
  margin-right: 4px
  color: #ff4d4f
  font-size: 14px
  font-family: SimSun, sans-serif
  line-height: 1
</style>
